import { IconListNumbers } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const NumberedListTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleOrderedList().run()}
      disabled={
        disabled || !editor.can().chain().focus().toggleOrderedList().run()
      }
      className={editor.isActive('orderedList') ? 'is-active' : ''}
    >
      <IconListNumbers width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
